<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import errorReporter from '@/utils/error-reporter';
import windowUtils from '@/utils/window-utils';
import pageVisibility from '@/utils/page-visibility';

const App = {
  name: 'App',

  async beforeCreate() {
    const g2wEnv = windowUtils.readQueryParameter('g2wEnv', this.$route);
    if (g2wEnv) {
      this.$store.commit('g2wEnv/setCurrent', {name: g2wEnv});
    }

    const {uuid, machineId} = this.$store.state.g2wEnv;

    errorReporter.setContext({ machineId, uuid });

    this.logger.setRootContext('machineId', machineId);
    this.logger.setRootContext('uuid', uuid);

    const {loggingUrl} = this.$store.state.g2wEnv.current;
    if (loggingUrl) {
      this.logger.startLoggingService({server: this.$store.state.g2wEnv.current.loggingUrl});
    }

    const setLng = windowUtils.readQueryParameter('setLng', this.$route);
    if (setLng) {
      this.$store.commit('g2wEnv/setLocale', {locale: setLng});
    }

    const nps = windowUtils.readQueryParameter('nps', this.$route);
    if (/^(default|never|always)$/i.test(nps)) {
      this.$store.commit('setNpsMode', {npsMode: nps.toLowerCase()});
    }

    this.logger.log('app start', {
      version: VERSION,
      environment: this.$store.state.g2wEnv.current.name,
      host: windowUtils.getWindowLocation().host,
      locale: this.$i18n.locale,
      localTime: new Date().toString(),
      uuid,
      machineId
    });

    this.$telemetrySetContext({uuid, machineId});

    const embed = windowUtils.readBooleanQueryParameter('embed', this.$route);
    this.$store.commit('setEmbed', {embed});

    const testMode = windowUtils.readBooleanQueryParameter('test', this.$route);
    this.$store.commit('setTestMode', {testMode});

    const debugMode = windowUtils.readBooleanQueryParameter('debug', this.$route) || testMode;
    this.$store.commit('setDebugMode', {debugMode});

  },

  created() {
    pageVisibility.startTracking(this.logVisibility);
  },

  beforeDestroy() {
    pageVisibility.stopTracking(this.logVisibility);
  },

  computed: {
    error() {
      return this.$store.state.error;
    },

    locale() {
      return this.$store.state.g2wEnv.locale;
    }
  },

  watch: {
    locale(newValue) {
      this.$i18n.locale = newValue;
    }
  },

  methods: {
    hideError() {
      const error = this.error;
      this.$store.commit('setError', {error: null});

      if (error.nextRoute) {
        this.$router.push(error.nextRoute);
      } else {
        this.$router.push({name: 'landing'});
      }
    },

    logVisibility(isVisible) {
      this.logger.log('VisibilityState', { isVisible });
    }
  }
};

export default App;
</script>

<style lang="sass">
  #app
    position: absolute
    top: 0
    bottom: 0
    width: 100%
    height: 100%
    overflow: auto
</style>
